import { toast } from 'react-hot-toast';
export const handleApiResponse = (status, response, Callback, isLogout = false, ShowToast = true) => {
    if (status) {
        console.log('chk4', status);

        // let errorMessage = response?.errors?.[0]?.message || response.message;

        switch (status) {
            case 200:
            case 201:
                if (ShowToast && response?.message && response.message !== 'ok' && response.message !== 'OK') {
                    toast.success(response.message);
                }
                Callback(response);
                break;
            case 204:
                if (ShowToast && response?.message && response.message !== 'ok' && response.message !== 'OK') {
                    toast.success(response.message);
                }
                Callback(response);
                break;
            // case 400:
            case 404:
            case 500:
                console.error('🚨', response?.data?.title || response?.message || '500');
                if (ShowToast && response?.message) {
                    toast.error(response.message);
                }
                break;
            case 401:
                console.error('🚫', response?.data?.title || response?.message || '401');
                if (isLogout) {
                    localStorage.removeItem('token');
                    window.location.reload();
                }
                break;
            case 429:
                toast.error('Too many requests, please try again later.');
                break;
            default:
                console.log('❗ 🚧', response?.data?.title || response?.message || 'Unhandled response status:', status);
                break;
        }
    } else {
        console.log('❗ 🚧', 'Invalid or missing status in response:', response);
    }
};

export function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}


export function arrayBufferToBase64(buffer) {
    const binary = [];
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
        binary.push(String.fromCharCode(bytes[i]));
    }
    return btoa(binary.join(''));
}